import { render, staticRenderFns } from "./client-listing.vue?vue&type=template&id=b23f3fc6&scoped=true"
import script from "./client-listing.vue?vue&type=script&lang=js"
export * from "./client-listing.vue?vue&type=script&lang=js"
import style0 from "./client-listing.vue?vue&type=style&index=0&id=b23f3fc6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b23f3fc6",
  null
  
)

export default component.exports